import React from "react";
import { motion } from "framer-motion";
import Accenture from "../../Assets/images/ClientImages/Accenture.jpg";
import Aci from "../../Assets/images/ClientImages/ACI.jpg";
import agco from "../../Assets/images/ClientImages/AGCO.jpg";
import atT from "../../Assets/images/ClientImages/atT.jpg";
import bd from "../../Assets/images/ClientImages/BD.jpg";
import birlaSoft from "../../Assets/images/ClientImages/birlaSoft.jpg";
import capastone from "../../Assets/images/ClientImages/capstone.jpg";
import cardware from "../../Assets/images/ClientImages/cardware.jpg";
import citybank from "../../Assets/images/ClientImages/CityBank.jpg";
import cognizant from "../../Assets/images/ClientImages/cognizant.jpg";
import cox from "../../Assets/images/ClientImages/cox.jpg";
import credit from "../../Assets/images/ClientImages/credit-Suisse.jpg";
import dataf from "../../Assets/images/ClientImages/Dataforensics.jpg";
import elevate from "../../Assets/images/ClientImages/Elevate.jpg";
import evq from "../../Assets/images/ClientImages/EVQ.jpg";
import ey from "../../Assets/images/ClientImages/EY.jpg";
import fed from "../../Assets/images/ClientImages/FedEx.jpg";
import firstdata from "../../Assets/images/ClientImages/First-Data.jpg";
import fluor from "../../Assets/images/ClientImages/Fluor.jpg";
import genpact from "../../Assets/images/ClientImages/Genpact.jpg";
import Global from "../../Assets/images/ClientImages/Global-Payments.jpg";
import Harsco from "../../Assets/images/ClientImages/Harsco.jpg";
import healthport from "../../Assets/images/ClientImages/healthport.jpg";
import Jackson from "../../Assets/images/ClientImages/Jackson.jpg";

const motionVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

const logoMotionVariants = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: (index) => ({
    opacity: 1,
    scale: 1,
    transition: { duration: 0.4, delay: index * 0.05 },
  }),
};

const logos = [
  Accenture, Aci, agco, atT, bd, birlaSoft, capastone, cardware, citybank, cognizant,
  cox, credit, dataf, elevate, evq, ey, fed, firstdata, fluor, genpact, Global,
  Harsco, healthport, Jackson
];

const OurClientele = () => {
  return (
    <section className="py-14 bg-gradient-to-r rounded-xl">
      <div className="max-w-6xl mx-auto px-4">
        <motion.h2
          variants={motionVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="text-4xl font-extrabold text-center mb-12 tracking-tight text-slate-200"
        >
          Our Clientele
        </motion.h2>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-8">
          {logos.map((logo, index) => (
            <motion.div
              key={index}
              custom={index}
              variants={logoMotionVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              className="flex justify-center items-center p-4 rounded-xl shadow-2xl hover:scale-100 transition-shadow duration-300"
            >
              <img
                src={logo}
                alt={`Client logo ${index + 1}`}
                className="max-h-20 transition duration-500 object-contain"
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurClientele;
